import { render, staticRenderFns } from "./ProductTimeline.vue?vue&type=template&id=aefa1a3c"
import script from "./ProductTimeline.vue?vue&type=script&lang=js"
export * from "./ProductTimeline.vue?vue&type=script&lang=js"
import style0 from "./ProductTimeline.vue?vue&type=style&index=0&id=aefa1a3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports